<template>
  <div class="container-fluid vld-parent">
    <loading :active.sync="isLoading" :is-full-page="false"></loading>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between"
        >
          <h4 class="mb-0 font-size-18">Detail {{ module }}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboards' }"
                  >Dashboards</router-link
                >
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: table_module }">{{
                  module
                }}</router-link>
              </li>
              <li class="breadcrumb-item active">detail</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="dataLoad">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="media align-items-center d-flex">
              <div class="avatar-md mr-3">
                <span
                  class="avatar-title rounded-circle bg-soft-primary text-primary font-size-20"
                >
                  <i class="bx bx-car"></i>
                </span>
              </div>
              <div class="media-body overflow-hidden">
                <h5 class="text-truncate font-size-18 mt-1">
                  {{ data.crs_model_name }}
                </h5>
                <router-link
                  :to="{
                    name: 'cars_brand_detail',
                    params: { uuid: data.crs_brand_uuid },
                  }"
                  >{{ data.crs_brand_name }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h5 class="font-size-15">Details :</h5>
            <p class="text-muted mb-4" v-html="data.crs_model_description"></p>
          </div>
          <div class="card-footer bg-white border-top">
            <div class="d-flex justify-content-between">
              <div class>
                <h5 class="font-size-14">CC</h5>
                <p class="font-size-14 mb-0">
                  <b>{{ data.crs_model_cc }}</b>
                </p>
              </div>
              <div class="t">
                <h5 class="font-size-14">Transmitions</h5>
                <p class="text-muted mb-0">{{ data.crs_model_transmission }}</p>
              </div>
              <div class="t">
                <h5 class="font-size-14">Mesin Type</h5>
                <p class="text-muted mb-0">{{ data.crs_model_type }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card min-h-350">
      <div class="card-body">
        <div class="d-flex align-items-center justify-content-between">
          <h4 class="card-title mb-0">Services</h4>
          <template v-if="local_users.usr_admin != ''">
            <button
              type="button"
              class="btn btn-secondary waves-effect waves-light btn-sm right-bar-toggle"
              @click="qucikCreateShow(true)"
            >
              <i class="bx bx-plus mr-2"></i> New
            </button>
          </template>
        </div>
        <tables
          module="Regular Servis"
          table_module="services"
          alias_table="srv"
          :data="data_services"
          :fields="fields_services"
          :local_users="local_users"
          @fetchData="fetchData"
          :hidden-checkbox="false"
          :sortable="{
            orderBy: orderBy,
            sort: sort,
          }"
        ></tables>
      </div>
    </div>

    <quickCreate
      v-if="childDataLoaded"
      :visible="visible"
      :fields="fields_services"
      module="Regular Servis"
      table_module="services"
      alias_table="srv"
      @hiddenSideSearch="visible = false"
      @fetch="fetchData"
      :defaultValue="{
        crs_model_id: data.crs_model_id,
        crs_brand_id: data.crs_brand_id,
      }"
    ></quickCreate>
  </div>
</template>

<script>
import tables from "@/components/tables";
import quickCreate from "@/components/quick_create";

export default {
  data() {
    return {
      visible: false,
      show: 10,
      page: 1,
      isLoading: false,
      module: "Model Mobil",
      table_module: "cars_model",
      alias_table: "crs_model",
      uuid: this.$route.params.uuid,
      data: {},
      fields_services: {},
      data_services: {},
      dataSearch: {},
      childDataLoaded: false,
      dataLoad: false,
      orderBy: "created_at",
      sort: "desc",
    };
  },
  components: {
    tables,
    quickCreate,
  },
  mounted() {
    this.fetchDetail();
  },
  computed: {
    local_users() {
      if (localStorage.getItem("users") != undefined) {
        return JSON.parse(localStorage.getItem("users"));
      }
      return {};
    },
  },
  methods: {
    fetchDetail() {
      this.isLoading = true;
      this.axios
        .get("/" + this.table_module + "/detail/" + this.uuid)
        .then((response) => {
          this.isLoading = false;
          this.data = response.data.data;
          this.dataLoad = true;
          this.fetchData();
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response) {
            this.$toast.error("Data tidak ada");
            this.$router.push({ name: this.table_module });
          } else if (error.request) {
            console.log("Error", error.message);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    fetchData(arm) {
      this.fields_services = {};
      this.visible = false;
      var params = {};
      if (arm == undefined) {
        params = {
          page: this.page,
          show: this.show,
          order_by: this.orderBy,
          type_sort: this.sort,
        };
      } else {
        params = {
          page: arm.page == undefined ? this.page : arm.page,
          show: arm.show == undefined ? this.show : arm.show,
          order_by: arm.orderBy == undefined ? this.orderBy : arm.orderBy,
          type_sort: arm.sort == undefined ? this.sort : arm.sort,
        };
      }

      this.orderBy = params.order_by;
      this.sort = params.type_sort;

      if (this.dataSearch.search != undefined) {
        for (const key in this.dataSearch.search) {
          params["search[" + key + "]"] = this.dataSearch.search[key];
        }
      }

      params["filter[crs_model_id]"] = this.data.crs_model_id;

      this.axios.get("/services", { params: params }).then((response) => {
        this.fields_services = response.data.data.fields;
        this.data_services = response.data.data["services"];
        this.childDataLoaded = true;
      });
    },
    qucikCreateShow(arm) {
      this.visible = arm;
    },
  },
};
</script>